import TYPES from '../../action-types';
import addHighlight from './addHighlight';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';
import Toast from '../../../components/Toast';
import checkNestedCollection from '../../helpers/assets/checkNestedCollection';

/**
 * Add assets to collection immediately
 * @param {Object} params
 * @param {string[]} params.ids - assets ids
 * @param {string} _id - collection id
 * @param {string} params.path - collection path
 */

const addedToCollection = ({
  ids, _id, path, showToast, isMove = false,
}) => async (dispatch, getAll) => {
  addHighlight(ids, 'collections')(dispatch);
  const { collectionIds: activeCollectionID } = getAll().router.location.query;
  const { collections } = getAll();

  const { isMoveIntoNestedCollection } = await checkNestedCollection({
    path,
    activeCollectionID,
    collections,
  });

  dispatch({
    type: TYPES.ASSETS.ADD_COLLECTION.COMPLETE,
    payload: {
      ids,
      collectionID: _id,
      collectionPath: path,
      isTeamDrive: false,
      activeCollectionID,
      isMove,
      isMoveIntoNestedCollection,
    },
  });

  if (showToast) {
    let pathWithoutRoot = path;
    if (pathWithoutRoot.includes('root')) {
      pathWithoutRoot = pathWithoutRoot.replace('/root/', '');
    }
    Toast(
      localization.COLLECTIONS.textFilesAddedToCollection(
        ids.length,
        utils.decodeSlash(pathWithoutRoot),
      ),
      { type: 'success', closeButton: false },
    );
  }
};

export default addedToCollection;
